import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLike, curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {GetAttributeSetParameters} from "#template/nodes/geometry-graph/attribute-set/get-attribute-set/geometry-get-attribute-set-node"
import {
    GeometryGetAttributeSetNode,
    getAttributeSetParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/get-attribute-set/geometry-get-attribute-set-node"

export type CurveGeometryGetAttributeSetParameters = GetAttributeSetParameters<CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryGetAttributeSetParameters> = {
    nodeClass: "CurveGeometryGetAttributeSet",
    validation: {
        parameters: getAttributeSetParametersSchema(curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryGetAttributeSet
    extends GeometryGetAttributeSetNode<1, CurveGeometryAttributeSetLikeNode>
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
